"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionKind = void 0;
exports.QuestionKind = {
    multiLineText: 'MULTI_LINE_TEXT',
    singleLineText: 'SINGLE_LINE_TEXT',
};
